"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
/**
 * Functionality for opening header menus.
 *
 * @author Kevin Buchholz <kevin.buchholz@wendweb.de>
 */
var HeaderMenu = /** @class */ (function () {
    function HeaderMenu(selector) {
        this.header = document.querySelector(selector);
        if (this.header) {
            this.headerMenuBtn = this.header.querySelector("[".concat(constants_1.DATA_HEADER_MENU_BTN, "]"));
            this.headerMenuMobile = this.header.querySelector("[".concat(constants_1.DATA_HEADER_MENU_MOBILE, "]"));
            this.headerMenuMobileLinks = this.headerMenuMobile.querySelectorAll("[".concat(constants_1.DATA_HEADER_MENU_MOBILE_LINK, "]"));
            this.headerMenuDesktopLinks = this.header.querySelectorAll("[".concat(constants_1.DATA_HEADER_MENU_DESKTOP_LINK, "]"));
            this.headerMenuDropdownWrapper = this.header.querySelector("[".concat(constants_1.DATA_HEADER_MENU_DROPDOWN_WRAPPER, "]"));
            this.headerMenuDropdowns = this.headerMenuDropdownWrapper.querySelectorAll("[".concat(constants_1.DATA_HEADER_MENU_DROPDOWN, "]"));
            this.initMobileMenu();
            this.initDesktopMenu();
        }
    }
    /**
     * Init mobile menu components
     */
    HeaderMenu.prototype.initMobileMenu = function () {
        var _this = this;
        // Open/Close menu
        this.headerMenuBtn.addEventListener('click', function () {
            _this.headerMenuMobile.classList.toggle(constants_1.CLASS_OPEN);
            _this.headerMenuBtn.classList.toggle(constants_1.CLASS_OPEN);
            // Close all open sub menus
            _this.headerMenuMobileLinks.forEach(function (element) {
                element.classList.remove(constants_1.CLASS_OPEN);
            });
        });
        // Open sub link menu
        this.headerMenuMobileLinks.forEach(function (element) {
            element.addEventListener('click', function () {
                element.classList.add(constants_1.CLASS_OPEN);
            });
            // Close sub link menu btn
            var backBtn = element.querySelector("[".concat(constants_1.DATA_HEADER_MENU_MOBILE_LINK_BACK, "]"));
            backBtn.addEventListener('click', function () {
                setTimeout(function () {
                    element.classList.remove(constants_1.CLASS_OPEN);
                }, 100);
            });
        });
    };
    /**
     * Init desktop menu components
     */
    HeaderMenu.prototype.initDesktopMenu = function () {
        var _this = this;
        this.headerMenuDesktopLinks.forEach(function (element) {
            element.addEventListener('click', function () {
                var linkDropdownID = element.dataset.dropdownId;
                _this.headerMenuDropdowns.forEach(function (dropdown) {
                    // Close other open dropdowns
                    if (dropdown.classList.contains(constants_1.CLASS_OPEN) && dropdown.dataset.dropdownId != linkDropdownID) {
                        dropdown.classList.remove(constants_1.CLASS_OPEN);
                    }
                    // Open dropdown
                    if (dropdown.dataset.dropdownId == linkDropdownID) {
                        dropdown.classList.toggle(constants_1.CLASS_OPEN);
                    }
                    var closeBtn = dropdown.querySelector("[".concat(constants_1.DATA_HEADER_MENU_DESKTOP_CLOSE, "]"));
                    // Close dropdown
                    closeBtn.addEventListener('click', function () {
                        dropdown.classList.remove(constants_1.CLASS_OPEN);
                    });
                });
            });
        });
    };
    return HeaderMenu;
}());
exports.default = HeaderMenu;
